import React from 'react'
import { getFileName } from '../../../../helpers/FileCaching';
import classes from './FooterImage.scss';
const globalImages = require.context('../../../../images/components/Global', true, /.*\.(gif|png|jpe?g|svg)$/i);

function FooterImage(props){
	return (
		<div className={"footerImage"}>
			<div className={"footerImage__container"}>
				
				<div className={"footerImage__image"} style={{backgroundImage: `url(${getFileName(globalImages, props.content[0].image[props.windowSize])})`}} title="footer image">
				</div>
			</div>
		</div>
		
	)
}

export default FooterImage